<template>
  <v-card max-width="300px" flat v-if="infoExist">
    <v-card-title>{{ $t('shooting.contactInfo') }}</v-card-title>
    <v-card-text>
      <div v-for="(contactInformation, index) in contactInformations" :key="index">
        <span>{{ contactInformation.title }} : </span>
        <span>{{ contactInformation.value }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ContactInformationPlayer',

  computed: {
    ...mapState({
      contactInformations: (state) => state.contactInformations
    }),
    infoExist() {
      return this.contactInformations && this.contactInformations.length > 0
    }
  }
}
</script>

<style lang="sass" scoped></style>
